import React, { useState } from 'react';
import api from '../api';

export default function Credentials() {
  const [shown, setShown] = useState(false);
  const [text, setText] = useState('');

  const reveal = async () => {
    if (!window.confirm('ATENÇÃO: as credenciais serão exibidas em tela. Continuar?')) return;
    try { const r = await api.get('/credentials'); setText(r.data.content); setShown(true); }
    catch (e) { alert(e.response?.data?.error || 'Erro'); }
  };

  return (
    <>
      <div className="page-title"><h1>Credenciais</h1></div>
      {!shown ? (
        <div className="card" style={{maxWidth:'500px'}}>
          <p>O arquivo CREDENCIAIS.txt contém todas as senhas do sistema.</p>
          <button onClick={reveal}>Mostrar credenciais</button>
        </div>
      ) : (
        <>
          <pre className="code" style={{maxHeight:'70vh', overflow:'auto'}}>{text}</pre>
          <div style={{marginTop:'.6rem'}}>
            <button onClick={() => navigator.clipboard.writeText(text)} className="secondary">Copiar tudo</button>
            <button onClick={() => setShown(false)} className="ghost" style={{marginLeft:'.5rem'}}>Ocultar</button>
          </div>
        </>
      )}
    </>
  );
}
